import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { TypedFormGroup } from '@feature/forms/form-model';

export type AlertType = 'blank' | 'danger' | 'error' | 'info' | 'neutral' | 'success' | 'warn';

@Component({
    selector: 'wai-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AlertComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @HostBinding('class.wai-alert') public className = true;
  public hidden = false;
  @Input() public persistent = true;
  @Input() public type: AlertType = 'blank';

  public get icon(): string {
    const map: Record<AlertType, string> = {
      blank: 'info',
      danger: 'error',
      error: 'error',
      info: 'info',
      neutral: 'info',
      success: 'check_circle',
      warn: 'warning',
    };

    return map[this.type];
  }
}
